module.exports = __webpack_public_path__ + "static/media/5DPO10.1d54ee78.jpg";